import { useCallback } from 'react';
import type { NavigationPageItem } from '@locus-taxy/encore-mui';

/**
 * Returns a callback matching encore-mui's `onNavigationItemClick` signature.
 *
 * Note: Navigation (including teams query-param preservation) is handled by
 * the `linkComponent` slot (RouterLink), which receives the fully-computed
 * `href` from DashboardNavItem. The `NavigationPageItem` passed to this
 * callback does not carry `href` — only `segment`, `title`, and metadata.
 *
 * This hook exists as a supplementary hook for side-effects (e.g. analytics,
 * closing mobile drawers) triggered on navigation clicks. It intentionally
 * does NOT call `navigate()` or `preventDefault()` because RouterLink already
 * handles the route transition.
 */
export function useNavigationClickHandler(): (
  item: NavigationPageItem,
  event: React.MouseEvent
) => void {
  return useCallback((_item: NavigationPageItem, _event: React.MouseEvent) => {
    // RouterLink (linkComponent slot) handles navigation and teams param.
    // Extend this callback for analytics or UI side-effects as needed.
  }, []);
}
